export const controlStyles = {
  disabled: 'cursor-not-allowed! opacity-50!',
  base: 'w-full relative outline-hidden items-center flex flex-wrap relative rounded-lg border-0 text-xs ring-offset-0 ring-1 ring-ui-bevel min-h-[28px]! bg-input-background',
  error: 'ring-red-500! focus-within:ring-red-500!',
  focus: 'outline-hidden! border-0! hover:border-0! ring-2! ring-ui-separator! ring-offset-0! duration-150!',
  nonFocus: 'border !border-ui-bevel hover:!border-ui-bevel',
  indeterminate: 'bg-status-warning/25 ring-status-warning/50 dark:ring-status-warning-dark/50',
};
export const indeterminatePlaceholderStyles = 'text-status-warning italic';
export const placeholderStyles = 'text-text-gray-alternate pl-1';
export const selectInputStyles = 'pl-0.5 dark:text-white! text-black';
export const valueContainerStyles = 'pl-1 py-1 overflow-y-auto! min-h-[16px]! max-h-[145px] gap-1 scrollbar-none';
export const singleValueStyles = 'leading-7 ml-1 dark:text-white!';
export const multiValueStyles = 'bg-ui-light rounded-xl gap-x-2 items-center flex px-3 py-0.5';
export const indeterminateMultiValueStyles = 'bg-status-warning dark:bg-status-warning';
export const multiValueLabelStyles = 'font-medium text-text-gray min-w-0 wrap-anywhere whitespace-break-spaces!';
export const indeterminateMultiValueLabelStyles = 'text-black dark:text-black';
export const multiValueRemoveStyles = 'shrink-0 hover:text-red-400 text-text-gray-alternate duration-200';
export const clearIndicatorStyles = 'text-icon-base dark:hover:text-red-800! hover:text-red-400!';
export const indeterminateClearIndicatorStyles = 'text-status-warning dark:hover:text-red-800! hover:text-red-400!';
export const indicatorSeparatorStyles = 'bg-ui-base w-px self-stretch';
export const indeterminateIndicatorSeparatorStyles = 'bg-status-warning/25 dark:bg-status-warning-dark/25';
export const indeterminateDropdownIndicatorStyles = 'text-status-warning';
export const dropdownIndicatorStyles = 'text-icon-base hover:text-text-gray';
export const menuStyles = 'z-100 absolute w-full my-1 rounded-[10px] border border-ui-bevel bg-ui-container shadow';
export const groupHeadingStyles = 'text-text-gray-alternate text-xs uppercase pt-2 pb-1 px-2 font-semibold';
export const optionStyles = {
  base: 'cursor-default rounded-[5px] py-1.5 px-2 text-sm wrap-anywhere',
  focus: 'bg-neutral-100! dark:bg-neutral-800!',
  selected: "after:content-['✓'] after:ml-2 after:text-highlight-base text-black! dark:text-white!",
  disabled: 'pointer-events-none! opacity-50!',
};
export const menuList = 'p-1';
export const noOptionsMessageStyles = 'text-text-gray-alternate px-2 py-6 text-center';
